import { describeSaveState, type DocumentStateStore } from './state';

/** "Modified for X min" has to keep up on its own, without any edit happening. */
const REFRESH_MS = 30_000;

export function createStatusPill(store: DocumentStateStore, signal?: AbortSignal): HTMLElement {
  const el = document.createElement('span');
  el.className = 'pill';

  const render = () => {
    const { text, level } = describeSaveState(store.get().save);
    el.textContent = text;
    el.dataset['level'] = level;
  };

  const unsubscribe = store.subscribe(render);
  const timer = setInterval(render, REFRESH_MS);

  signal?.addEventListener('abort', () => {
    clearInterval(timer);
    unsubscribe();
  });

  return el;
}
